import dayjs from 'dayjs';
import { SERVICE_TYPE_A2, SERVICE_TYPE_BOTH, SERVICE_TYPE_R2 } from '@/constants/serviceType';

export type ManagerItem = {
  service_type?: string | null;
  available_to?: string | null;
};

function isManagerExpired(availableTo: string | null | undefined): boolean {
  if (!availableTo) return false;
  const md = dayjs(availableTo, 'YYYY-MM-DD');
  const today = dayjs().startOf('day');
  return md.isValid() && md.isBefore(today, 'day');
}

function hasValidManager(managers: ManagerItem[]): boolean {
  return managers.some(m => !isManagerExpired(m.available_to));
}

export function getManagerWarningMessage(
  managers: ManagerItem[],
  isA2Provided: boolean,
  isR2Provided: boolean
): string | null {
  const st = (s: string | null | undefined) => (s ?? '').toUpperCase();
  if (managers.length === 0) {
    return '施術管理者の登録がありません。登録してください';
  }

  const a2Managers = managers.filter(
    m => st(m.service_type) === SERVICE_TYPE_A2 || st(m.service_type) === SERVICE_TYPE_BOTH
  );
  const r2Managers = managers.filter(
    m => st(m.service_type) === SERVICE_TYPE_R2 || st(m.service_type) === SERVICE_TYPE_BOTH
  );

  if (isA2Provided && isR2Provided) {
    const noA2 = a2Managers.length === 0;
    const noR2 = r2Managers.length === 0;

    if (noR2) {
      if (a2Managers.length > 0 && hasValidManager(a2Managers)) {
        return 'マッサージ管理者の登録がありません。登録してください';
      }
      return '施術管理者の登録がありません。登録してください';
    }

    if (noA2) {
      if (r2Managers.length > 0 && hasValidManager(r2Managers)) {
        return 'はり・きゅう管理者の登録がありません。登録してください';
      }
      return '施術管理者の登録がありません。登録してください';
    }

    const a2Valid = hasValidManager(a2Managers);
    const r2Valid = hasValidManager(r2Managers);
    if (!a2Valid && !r2Valid) return '施術管理者の登録がありません。登録してください';
    if (!a2Valid && r2Valid) return 'はり・きゅう管理者の登録がありません。登録してください';
    if (a2Valid && !r2Valid) return 'マッサージ管理者の登録がありません。登録してください';
    return null;
  }

  if (isA2Provided) {
    if (a2Managers.length === 0) {
      return 'はり・きゅう管理者の登録がありません。登録してください';
    }
    if (!hasValidManager(a2Managers)) {
      return 'はり・きゅう管理者の登録がありません。登録してください';
    }
  }

  if (isR2Provided) {
    if (r2Managers.length === 0) {
      return 'マッサージ管理者の登録がありません。登録してください';
    }
    if (!hasValidManager(r2Managers)) {
      return 'マッサージ管理者の登録がありません。登録してください';
    }
  }

  return null;
}
